import React, { useState } from "react";
import { doc, setDoc } from "firebase/firestore";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import {
  uploadBytesResumable,
  ref as ref_storage,
  getDownloadURL,
} from "firebase/storage";
import { db, storage } from "../../context/firebase";
import {
  CircularProgress,
  Typography,
  Button,
  TextField,
} from "@material-ui/core";
import useStyles from "./styles";

function StudentRegister() {
  var classes = useStyles();
  var [isLoading, setIsLoading] = useState(false);
  const navigate = useHistory();
  const [name, setName] = useState("");
  const [batch, setBatch] = useState("");
  const [whatsapp_no, setWhatsapp_no] = useState("");
  const [contact_no, setContact_no] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [image, setImage] = useState(null);
  const [is_img_big, setIs_img_big] = useState(false);
  const [is_img_format_correct, setIs_img_format_correct] = useState(true);

  const [imageurl, setImageurl] = useState(null);
  var [isregistered, setIsregistered] = useState(false);

  const getimage = (event) => {
    console.log(event.target.files[0]);
    var img = event.target.files[0];
    setIs_img_big(false);
    setIs_img_format_correct(true);
    setImage(null);
    // if(img.size<=512000 && (img.type =="image/jpeg" || img.type =="image/png")){
    //   setIs_img_big(false);
    //   setImage(img);
    // }
    // else{
    //   setImage(null)
    //   setIs_img_big(true);
    // }

    if (img.size > 512000){
      setIs_img_big(true);
      return
    } 

    if (img.type != "image/jpeg" && img.type != "image/png"){
      setIs_img_format_correct(false)
      return ;
    }
     

    setImage(img);
  };

  const uploadImage = () => {
    console.log(image);

    const storageRef = ref_storage(
      storage,
      "userimages/" + batch + "/" + image.name
    );

    const uploadTask = uploadBytesResumable(storageRef, image);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        // Observe state change events such as progress, pause, and resume
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log("Upload is " + progress + "% done");
        switch (snapshot.state) {
          case "paused":
            console.log("Upload is paused");
            break;
          case "running":
            console.log("Upload is running");
            break;
          default:
            console.log("Default case");
            break;
        }
      },
      (error) => {
        alert("Error:" + error);
      },
      () => {
        // Handle successful uploads on complete
        // For instance, get the download URL: https://firebasestorage.googleapis.com/...
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          console.log("File available at", downloadURL);

          setImageurl(downloadURL);
        });
      }
    );
  };

  function showToast_onsucess() {
    toast.success("You Registration completed.We will get back to you Soon.", {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }
  function showToast_error() {
    toast.error("❌Error, Please register again", {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }

  async function getRandomString(length) {
    var charset =
      "abcdefghijklmnopqrstuvwxyz" +
      "ABCDEFGHIJKLMNOPQRSTUVWXYZ" +
      "0123456789";
    var id = "";
    for (let i = 0; i < length; i++) {
      let i = Math.floor(Math.random() * 62);

      console.log(i);
      id += charset[i];
    }
    return id;
  }

  async function uploadData() {
    var uid = await getRandomString(30);
    console.log(uid);
    const temp_user = {
      name: name,
      batch: batch,
      whatsapp_no: whatsapp_no,
      contact_no: contact_no,
      email: email,
      password: password,
      image: imageurl,
      uid: uid,
      status: 0,
    };

    try {
      const docRef = await setDoc(doc(db, "temp_users", uid), temp_user);
      console.log(docRef);
      return 1;
    } catch (e) {
      console.error("Error adding document: ", e);
      return 0;
    }
  }

  const onSubmitForm = async (event) => {
    // event.preventDefault();

    // console.log(imageurl);
    var flag = uploadData();

    setIsregistered(true);
    if (flag) {
      showToast_onsucess();
    } else {
      showToast_error();
    }

    //  navigate.push("/login");
    // console.log(name);
    // console.log(batch);
    // console.log(whatsapp_no);
    // console.log(contact_no);
    // console.log(email);
    // console.log(password);
    // console.log(image);
    // console.log(imageurl);
  };

  return (
    <>
      {isregistered ? (
        <Typography variant="h5" className={classes.greeting}>
          Thank You for registering.We will confirm you soon.
          <br />
          <br />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            size="large"
            onClick={() => {
              setIsregistered(false);

              setName("");
              setBatch("");
              setWhatsapp_no("");
              setContact_no("");
              setEmail("");
              setPassword("");
              setImage(null);
              setImageurl(null);

              navigate("/#/login");
            }}
          >
            {" "}
            Home{" "}
          </Button>
        </Typography>
      ) : (
        <>
          <Typography variant="h5" className={classes.greeting}>
            New to ABPhysics?? Please Register here:
          </Typography>
          <form>
            <TextField
              id="name"
              InputProps={{
                classes: {
                  underline: classes.textFieldUnderline,
                  input: classes.textField,
                },
              }}
              value={name}
              onChange={(e) => setName(e.target.value)}
              margin="normal"
              placeholder="Enter your Full name"
              type="text"
              fullWidth
            />
            <TextField
              id="whatsapp_no"
              InputProps={{
                classes: {
                  underline: classes.textFieldUnderline,
                  input: classes.textField,
                },
              }}
              value={whatsapp_no}
              onChange={(e) => setWhatsapp_no(e.target.value)}
              margin="normal"
              placeholder="Whatsapp Number"
              type="number"
              fullWidth
            />
            <TextField
              id="contact_no"
              InputProps={{
                classes: {
                  underline: classes.textFieldUnderline,
                  input: classes.textField,
                },
              }}
              value={contact_no}
              onChange={(e) => setContact_no(e.target.value)}
              margin="normal"
              placeholder="Contact Number"
              type="number"
              fullWidth
            />
            <TextField
              id="email"
              InputProps={{
                classes: {
                  underline: classes.textFieldUnderline,
                  input: classes.textField,
                },
              }}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              margin="normal"
              placeholder="Email Address"
              type="email"
              fullWidth
            />
            <TextField
              id="password"
              InputProps={{
                classes: {
                  underline: classes.textFieldUnderline,
                  input: classes.textField,
                },
              }}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              margin="normal"
              placeholder="Password"
              type="password"
              fullWidth
            />
            <Typography variant="h6">Select Batch</Typography>
            <select
              value={batch}
              onChange={(e) => setBatch(e.target.value)}
              InputProps={{
                classes: {
                  underline: classes.textFieldUnderline,
                  input: classes.textField,
                },
              }}
            >
              <option value="">Select options</option>
              <option value="ABPhysicsClass11">AB PHYSICS Classs 11</option>
              <option value="ABPhysicsClass12">AB PHYSICS Class 12</option>
              <option value="ABPHYSICSFOCUS">AB PHYSICS FOCUS</option>
              <option value="ABPhysicsClass9">AB PHYSICS Class 9</option>
              <option value="ABPhysicsClass10">AB PHYSICS Class 10</option>
            </select>
            <br />
            <br />
            <Typography variant="h6">Upload Image</Typography>
            {is_img_big ? (
              <Typography style={{color: 'red'}}>Image size is above 500KB. Please choose image within 500KB</Typography>
            ) : (
              ""
            )}
            {!is_img_format_correct? (
              <Typography style={{color: 'red'}}>Image format should be in jpg/jpeg/png</Typography>
            ) : (
              ""
            )}
            {image && (
              <>
                <img
                  alt="not fount"
                  width={"250px"}
                  src={URL.createObjectURL(image)}
                />

                <br />
                <Button
                  onClick={() => setImage(null)}
                  variant="contained"
                  color="secondary"
                  size="small"
                >
                  Remove{" "}
                </Button>
                <br />
                <br />
              </>
            )}
            <input
              type="file"
              name="myImage"
              accept="image/png, image/jpeg"
              onChange={getimage}
            />
            <br /> <br />
            <Button
              onClick={uploadImage}
              disabled={image == null}
              variant="contained"
              color="primary"
              size="small"
            >
              Upload Image
            </Button>
            <div className={classes.formButtons}>
              {isLoading ? (
                <CircularProgress size={26} className={classes.loginLoader} />
              ) : (
                <Button
                  onClick={onSubmitForm}
                  disabled={
                    email.length === 0 ||
                    password.length === 0 ||
                    name.length === 0 ||
                    batch.length === 0 ||
                    whatsapp_no.length === 0 ||
                    contact_no.length === 0 ||
                    imageurl == null
                  }
                  variant="contained"
                  color="primary"
                  size="large"
                >
                  Register
                </Button>
              )}
            </div>
          </form>
        </>
      )}
    </>
  );
}

export default StudentRegister;
